import common from './common-educabot'

export default {
  ...common.button,
  color: `#FFFFFF`,
  '::before': {
    display: `none`
  },
  '::after': {
    ...common.button['::after'],
    bg: `#9B00AF`,
    border: '0.5px solid',
    borderColor: `#9B00AF`,
    '@media (max-width: 743px)': {
      borderColor: `#FFF`,
      height: '40px',
      marginTop: '1px'
    }
  }
}